import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatSortModule } from '@angular/material/sort';
import { RouterModule } from '@angular/router';

import { MgButtonModule } from '@app/src/app/button';
import {
  ManagerReportChartModule,
  ManagerReportChartSectionModule,
  ManagerReportDataTableModule,
  ManagerReportHeaderModule,
} from '@app/src/app/components/manager-report/components';
import { MgFormFieldModule } from '@app/src/app/form-field';
import { MgIconModule } from '@app/src/app/icon';
import { ScrollTargetDirectiveModule } from '@app/src/app/misc/ScrollTarget/directive';
import { MgOverlayToolsModule } from '@app/src/app/overlay/MgOverlayTools.module';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { AutomationCounterResetModule } from '@shared/components/automation-counter-reset/automation-counter-reset.module';
import { GenericButtonModule } from '@shared/components/button';
import { CollapsibleModule } from '@shared/components/collapsible';
import { CountTileModule } from '@shared/components/count-tile';
import { FiltersFormModule } from '@shared/components/filters-form';
import { FormModule } from '@shared/components/form';
import { GenericModule } from '@shared/components/generic';
import { ManagerOverlayModule } from '@shared/components/manager-overlay';
import { ModalOverlayService, OverlayModule } from '@shared/components/modal-overlay';
import { MultiPersonSearchModule } from '@shared/components/multi-person-search';
import { ReportTableModule } from '@shared/components/report-table';
import { SystemAlertModule } from '@shared/components/system-alert';
import { TextModule } from '@shared/components/text';
import { UserListFilterModule } from '@shared/components/user-list-filter/user-list-filter.module';
import { ArrayPipesModule } from '@shared/pipes';

import { BmReportsComponent } from './bm-reports.component';
import { BmReportsAutomationCounterComponent } from './components/bm-reports-auto-counter/bm-reports-auto-counter.component';
import { BmReportsAutoCounterResetComponent } from './components/bm-reports-auto-counter/components/bm-reports-auto-counter-reset/bm-reports-auto-counter-reset.component';
import { BmReportsConsHistoryEditComponent } from './components/bm-reports-cons-history/bm-reports-cons-history-edit.component';
import { BmReportsConsHistoryComponent } from './components/bm-reports-cons-history/bm-reports-cons-history.component';
import { BmReportsConsOverdueComponent } from './components/bm-reports-cons-overdue/bm-reports-cons-overdue.component';
import { BmReportsConsTypesComponent } from './components/bm-reports-cons-types/bm-reports-cons-types.component';
import { BmReportsHistoryEditComponent } from './components/bm-reports-history/bm-reports-history-edit.component';
import { BmReportsHistoryComponent } from './components/bm-reports-history/bm-reports-history.component';
import { BmReportsStaffComponent } from './components/bm-reports-staff/bm-reports-staff.component';
import { BmReportsStudentComponent } from './components/bm-reports-student/bm-reports-student.component';
import { BmReportsSummaryComponent } from './components/bm-reports-summary/bm-reports-summary.component';
import { BmReportsTypesComponent } from './components/bm-reports-types/bm-reports-types.component';

@NgModule({
  imports: [
    // Minga dependencies
    ManagerOverlayModule,
    GenericModule,
    MgButtonModule,
    MgIconModule,
    MgFormFieldModule,
    MgSpinnerModule,
    ScrollTargetDirectiveModule,
    ManagerReportHeaderModule,
    GenericButtonModule,
    FormModule,
    CollapsibleModule,
    MgOverlayToolsModule,
    MultiPersonSearchModule,
    CountTileModule,
    ManagerReportChartModule,
    ManagerReportChartSectionModule,
    ManagerReportDataTableModule,
    ArrayPipesModule,
    ReportTableModule,
    TextModule,
    OverlayModule,
    AutomationCounterResetModule,
    SystemAlertModule,
    UserListFilterModule,
    FiltersFormModule,

    // External dependencies
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatSortModule,
    MatInputModule,
    MatSelectModule,
    RouterModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatTableModule,
  ],
  declarations: [
    BmReportsComponent,
    BmReportsHistoryComponent,
    BmReportsStaffComponent,
    BmReportsStudentComponent,
    BmReportsSummaryComponent,
    BmReportsTypesComponent,
    BmReportsConsHistoryComponent,
    BmReportsConsTypesComponent,
    BmReportsAutomationCounterComponent,
    BmReportsAutoCounterResetComponent,
    BmReportsConsOverdueComponent,
    BmReportsHistoryEditComponent,
    BmReportsConsHistoryEditComponent,
  ],
  exports: [BmReportsComponent],
  providers: [ModalOverlayService],
})
export class BmReportsModule {}
